var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45312 20.4844V24H11.2969V20.4844C11.2969 19.3212 10.3507 18.375 9.1875 18.375H3.5625C2.39934 18.375 1.45312 19.3212 1.45312 20.4844Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 18.375C7.9283 18.375 9.1875 17.1158 9.1875 15.5625C9.1875 14.0092 7.9283 12.75 6.375 12.75C4.8217 12.75 3.5625 14.0092 3.5625 15.5625C3.5625 17.1158 4.8217 18.375 6.375 18.375Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 20.4844V24H22.5469V20.4844C22.5469 19.3212 21.6007 18.375 20.4375 18.375H14.8125C13.6493 18.375 12.7031 19.3212 12.7031 20.4844Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 18.375C19.1783 18.375 20.4375 17.1158 20.4375 15.5625C20.4375 14.0092 19.1783 12.75 17.625 12.75C16.0717 12.75 14.8125 14.0092 14.8125 15.5625C14.8125 17.1158 16.0717 18.375 17.625 18.375Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85938 4.21875C2.85938 6.54511 4.75177 8.4375 7.07812 8.4375V11.5981L10.8492 8.4375H13.1508L16.9219 11.5981V8.4375C19.2482 8.4375 21.1406 6.54511 21.1406 4.21875C21.1406 1.89239 19.2482 0 16.9219 0H7.07812C4.75177 0 2.85938 1.89239 2.85938 4.21875ZM14.1094 3.51562H15.5156V4.92188H14.1094V3.51562ZM11.2969 3.51562H12.7031V4.92188H11.2969V3.51562ZM8.48438 3.51562H9.89062V4.92188H8.48438V3.51562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.6eed78c3f0d93cd2369b695f00510af9.svg";
export { ForwardRef as ReactComponent };